import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'linerAd',
    initialState: {
        hideLinerAd0: false,
        hideLinerAd1: false,
        hideLinerAd2: false,
        hideLinerAd3: false,
        hideLinerAd4: false,
    },
}).extend({
    selectors: () => ({
        getHideLinerAd0: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideLinerAd0),
        getHideLinerAd1: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideLinerAd1),
        getHideLinerAd2: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideLinerAd2),
        getHideLinerAd3: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideLinerAd3),
        getHideLinerAd4: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideLinerAd4),
    }),
});
